import { useQuery } from 'react-query';

import {
  SUBSCRIPTION_STATUS_KEY,
  SubscriptionResponse,
  SubscriptionStatusParams,
  subscriptionStatus,
} from '@utils/backend-api/subscribe';

const useSubscriptionStatus = (params: SubscriptionStatusParams, enabled: boolean) => {
  const { data, refetch, isLoading, isError } = useQuery<SubscriptionResponse>(
    [SUBSCRIPTION_STATUS_KEY],
    () => subscriptionStatus(params),
    {
      enabled,
    }
  );
  return { data, refetch, isLoading, isError };
};

export default useSubscriptionStatus;
